import { useQuery } from '@zg-rentals/react-query5';
import { useDispatch, useSelector } from 'react-redux';
import { userIdIreneSelector } from '../../selectors';
import { getNames } from '../api';

/**
 * @param {import('@zg-rentals/react-query5').UseQueryOptions} useQueryOptions
 * @returns {import('@zg-rentals/react-query5').UseQueryResult}
 */
export default function useGetNames(useQueryOptions) {
  const userId = useSelector(userIdIreneSelector);
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ['getNames'],
    queryFn: () => dispatch(getNames([userId])),
    ...useQueryOptions,
  });
}
